<template>
  <VFiltersPopup
      :title-list="titleList"
      @submit="applyFilters"
      @clear="clearFilters"
  >
    <section class="outer-filter-container">
      <VSelect
          v-model="draft.responsible"
          label="Ответственный"
          placeholder="Выберите ответственного"
          :clearable="!filters.isLocked('responsible')"
          :disabled="filters.isLocked('responsible')"
          layout="vertical"
          :search-function="pattern => PersonsService.searchPersons(pattern, $core.currentPartner!.id)"
      />

      <VSelect
          v-model="draft.type"
          label="Категория ЗТК"
          placeholder="Выберите категорию"
          :clearable="!filters.isLocked('type')"
          :disabled="filters.isLocked('type')"
          layout="vertical"
          :options="TransportOrder.types"
      />
    </section>
  </VFiltersPopup>
</template>

<script lang="ts">

import VFiltersPopup                        from '@/components/VFiltersPopup/VFiltersPopup.vue';

import PersonsService                    from "@/domains/Persons/PersonsService";
import TransportOrdersRegistryFilter     from "@/domains/TransportOrders/components/TransportOrdersRegistry/TransportOrdersRegistryFilter.ts";
import TransportOrder                    from "@/domains/TransportOrders/TransportOrder";

export default defineComponent({
  name: 'TransportOrdersFilter',

  components: {
    VFiltersPopup,
  },

  props: {
    filters: {
      type: Object as PropType<TransportOrdersRegistryFilter>,
      required: true,
    },
  },

  emits: ['updated'],

  data() {
    return {
      PersonsService,
      TransportOrder,
      draft: this.$core.utils.cloneDeep(this.filters),
    };
  },

  computed: {
    titleList(): string[] {
      const texts: string[] = [];

      if (this.filters.responsible?.name) {
        texts.push(this.filters.responsible.name);
      }

      if (this.filters.type?.name) {
        texts.push('Тип ЗТК: ' + this.filters.type.name);
      }

      return texts;
    },
  },

  methods: {
    applyFilters(): void {
      this.draft.apply();
      this.$emit('updated', this.draft);

      this.draft = this.$core.utils.cloneDeep(this.draft);

    },

    clearFilters(): void {
      this.filters.reset();
      this.draft = this.$core.utils.cloneDeep(this.filters);
      this.$emit('updated', this.filters);
    },
  },
});
</script>